// URL hash <-> state, as "k=v&k=v" with comma-separated numbers.

export type HashState = Record<string, string>;

export function parseHash(h: string): HashState {
  const o: HashState = {};
  for (const kv of h.replace(/^#/, '').split('&')) {
    if (!kv) continue;
    const i = kv.indexOf('=');
    o[decodeURIComponent(i < 0 ? kv : kv.slice(0, i))] = i < 0 ? '' : decodeURIComponent(kv.slice(i + 1));
  }
  return o;
}

export function formatHash(o: HashState): string {
  return '#' + Object.entries(o).filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => (v === '' ? k : `${k}=${encodeURIComponent(v).replace(/%2C/g, ',')}`)).join('&');
}

/** Comma list of numbers, or null if missing/malformed/wrong length. */
export function nums(s: string | undefined, n?: number): number[] | null {
  if (s === undefined || s === '') return null;
  const a = s.split(',').map(Number);
  if (a.some(x => !Number.isFinite(x)) || (n !== undefined && a.length !== n)) return null;
  return a;
}

export const fmt = (a: number[], d = 3) => a.map(x => +x.toFixed(d)).join(',');
